module.exports = __webpack_public_path__ + "img/ico_order_plus.759eb0f1.svg";